import React, {useState,useEffect} from 'react'
import axios from 'axios'
import SearchCountry from './components/SearchCountry'
import ListCountries from './components/ListCountries'
import CountryInfo from './components/CountryInfo'
import './App.css'

const App = () => {
    const API_URL = 'https://restcountries.com/v3.1/all'

    const [countries, setCountries] = useState([])
    const [countriesList, setCountriesList] = useState([])
    const [targetCountry, setTargetCountry] = useState('')

    useEffect(() => {
        axios
            .get(API_URL)
            .then(response => setCountries(response.data))
    }, [])

    const handleInput = (e) => {
        const filteredCountries = countries.filter(country => {
            return country.name.common.toLowerCase().includes(e.target.value.toLowerCase())
        })
        if (e.target.value !== '') {
            setCountriesList(filteredCountries) 
        } else {
            setCountriesList([])
        }
    }

    const handleButton = (e) => {
        setTargetCountry(e.target.value)
    }

    return(
        <main>
            <h1>COUNTRIES INFO</h1>
            <SearchCountry 
                handleInput={handleInput} />
            {
                countriesList.length > 1 ?
                <>
                    <ul className='main-list'>
                        <ListCountries 
                            countriesList={countriesList}
                            handleButton={handleButton}/>
                    </ul>
                    <CountryInfo 
                        countriesList={countriesList}
                        targetCountry={targetCountry}/>
                </> :
                <section>
                    <ListCountries 
                        countriesList={countriesList}/>  
                </section>   
            }
        </main>
    )
}

export default App